module.exports = __webpack_public_path__ + "static/media/judo.2d058403.svg";